module.exports = __webpack_public_path__ + "img/logo_2.c8fa0481.svg";